import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from 'requests/rootAxios';

export const fetchTrailblazeConfigs = createAsyncThunk(
  'trainingConfig/fetchTrailblazeConfigs',
  async (_, { rejectWithValue }) => {
    try {
      const res = await rootAxios.get('/super-user/get-trailblaze-configs');
      return res.data.data.configs;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchAllCircles = createAsyncThunk(
  'trainingConfig/fetchAllCircles',
  async (_, { rejectWithValue }) => {
    try {
      const res = await rootAxios.get('/super-user/get-all-circles');
      return res.data.data.circles;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const saveTrailblazeConfig = createAsyncThunk(
  'trainingConfig/saveTrailblazeConfig',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await rootAxios.post('/super-user/save-trailblaze-config', payload);
      return res.data.data.config;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteTrailblazeConfig = createAsyncThunk(
  'trainingConfig/deleteTrailblazeConfig',
  async (payload, { rejectWithValue }) => {
    try {
      await rootAxios.delete('/super-user/delete-trailblaze-config', { data: payload });
      return payload;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const toggleTrailblazeConfig = createAsyncThunk(
  'trainingConfig/toggleTrailblazeConfig',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await rootAxios.put('/super-user/toggle-trailblaze-config', payload);
      return res.data.data.config;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const trainingConfigSlice = createSlice({
  name: 'trainingConfig',
  initialState: {
    configs: [],
    circles: [],
    loading: false,
    circlesLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrailblazeConfigs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrailblazeConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.configs = action.payload;
      })
      .addCase(fetchTrailblazeConfigs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllCircles.pending, (state) => {
        state.circlesLoading = true;
      })
      .addCase(fetchAllCircles.fulfilled, (state, action) => {
        state.circlesLoading = false;
        state.circles = action.payload;
      })
      .addCase(fetchAllCircles.rejected, (state) => {
        state.circlesLoading = false;
      })
      .addCase(saveTrailblazeConfig.fulfilled, (state, action) => {
        const idx = state.configs.findIndex(
          (c) =>
            c.trainerId === action.payload.trainerId &&
            c.trainingType === action.payload.trainingType
        );
        if (idx >= 0) state.configs[idx] = action.payload;
        else state.configs.unshift(action.payload);
      })
      .addCase(toggleTrailblazeConfig.fulfilled, (state, action) => {
        const idx = state.configs.findIndex(
          (c) =>
            c.trainerId === action.payload.trainerId &&
            c.trainingType === action.payload.trainingType
        );
        if (idx >= 0) state.configs[idx] = action.payload;
      })
      .addCase(deleteTrailblazeConfig.fulfilled, (state, action) => {
        state.configs = state.configs.filter(
          (c) =>
            !(
              c.trainerId === action.payload.trainerId &&
              c.trainingType === action.payload.trainingType
            )
        );
      });
  },
});

export default trainingConfigSlice.reducer;
